import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import LoginAggregate from '../model/aggregate/login-aggregate';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var LoginDomainService = /** @class */ (function () {
    function LoginDomainService(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    LoginDomainService.prototype.createLoginAggregate = function (tinyId) {
        this.loginAggregate = new LoginAggregate(this.networkRequestService, tinyId);
    };
    /**
     * 初始化登录domain
     * 无需统一初始化，提供空实现
     * 如若想初始化账号相关的数据，请查看接入文档：https://iwiki.woa.com/pages/viewpage.action?pageId=1902350186
     */
    LoginDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LoginDomainService.prototype, "init", null);
    LoginDomainService = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], LoginDomainService);
    return LoginDomainService;
}());
export { LoginDomainService };
